import React, { useState, useEffect, useContext } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import SendIcon from "@mui/icons-material/Send";
import Stack from "@mui/material/Stack";
import AuthContext from "../../context/AuthContext";
import { createTheme } from "@mui/material/styles";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import AddCommentIcon from "@mui/icons-material/AddComment";
import Fab from "@mui/material/Fab";
import Container from "@mui/material/Container";
import { PostType, ThreadType } from "../../utils/types";
import { Grid } from "@mui/material";
import TextEditor from "./TextEditor";

const ReplyEditForm = ({ initialPost }: { initialPost: PostType }) => {
  let { user } = useContext(AuthContext);

  const [alertShow, setAlertShow] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [post, setPost] = useState(initialPost);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  let handlePost = async (event) => {
    // check the authenticated user
    if (!user) {
      setAlertShow(true);
      event.preventDefault();
    }

    const response = await fetch(`/api/updatePosts/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(post),
    });
    const data = await response.json();
  };

  // add reply button style and theme
  const fabStyle = {
    margin: 0,
    top: "auto",
    bottom: 110,
    position: "fixed",
  };

  const fab = {
    sx: fabStyle,
    icon: <AddCommentIcon />,
    label: "Add",
  };

  const theme = createTheme({
    palette: {
      primary: {
        main: "#6a5acd",
      },
    },
  });

  return (
    <div>
      <Grid container justifyContent="flex-end">
        <Button
          variant="outlined"
          onClick={handleClickOpen}
          style={{
            maxWidth: "180px",
            maxHeight: "32px",
            minWidth: "100px",
            minHeight: "32px",
          }}
        >
          Bearbeiten
        </Button>
      </Grid>

      <Dialog fullWidth maxWidth="sm" open={open} onClose={handleClose}>
        <form onSubmit={handlePost} id="NewReplyForm">
          <Box>
            {alertShow && (
              <Alert severity="error" onClose={() => setAlertShow(false)}>
                Bitte melde dich an um zu antworten{" "}
                <Link href="/login">Hier anmelden.</Link>
              </Alert>
            )}
          </Box>

          <DialogTitle>Antwort aktualisieren</DialogTitle>
          <DialogContent>
            <DialogContentText>Antwort</DialogContentText>

            <TextEditor
              onChange={(value) =>
                setPost({
                  ...post,
                  content: value,
                })
              }
              value={post.content}
              placeholder={post.content}
            />
          </DialogContent>

          <DialogActions>
            <Stack direction="row" spacing={2}>
              <Button variant="outlined" onClick={handleClose}>
                Abbrechen
              </Button>
              <Button variant="contained" endIcon={<SendIcon />} type="submit">
                Speichern
              </Button>
            </Stack>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
};

export default ReplyEditForm;
